<!-- Retention Workflows Table Component -->
<!-- Following scheduled-orders-table pattern with frozen columns and mobile cards -->
<div class="retention-workflows-table">
  <p-table
    [value]="data"
    [loading]="loading"
    [scrollHeight]="scrollHeight"
    [scrollable]="true"
    scrollDirection="both"
    size="small"
    responsiveLayout="stack"
    breakpoint="768px"
    dataKey="survey.id"
    [rowExpandMode]="'single'"
    [expandedRowKeys]="expandedRows"
    (onRowExpand)="onRowExpand($event)"
    (onRowCollapse)="onRowCollapse($event)"
    styleClass="p-datatable-workflows"
  >
    <!-- Table Header -->
    <ng-template pTemplate="header">
      <tr>
        <!-- Expand/Collapse Column (Frozen Left) -->
        <th
          style="width: 2.5rem"
          class="text-center"
          pFrozenColumn
          [frozen]="true"
          alignFrozen="left"
        ></th>

        <!-- ID Column (Frozen Left) -->
        <th
          pFrozenColumn
          [frozen]="true"
          alignFrozen="left"
          class="id-column-header"
          style="width: auto; min-width: 4rem"
        >
          ID
        </th>

        <!-- Name Column -->
        <th style="min-width: 200px">Name</th>

        <!-- Trigger Column -->
        <th style="width: 6rem">Trigger</th>

        <!-- Enabled Column -->
        <th style="width: 5rem; text-align: center">Enabled</th>

        <!-- Created Column -->
        <th style="width: 7rem">Created</th>

        <!-- First Response Column (hidden on mobile) -->
        <th style="width: 8rem" class="desktop-only-cell">First response</th>

        <!-- Last Response Column (hidden on mobile) -->
        <th style="width: 8rem" class="desktop-only-cell">Last response</th>

        <!-- Actions Column (Frozen Right) -->
        <th
          style="width: 3rem"
          pFrozenColumn
          [frozen]="true"
          alignFrozen="right"
        >
          Actions
        </th>
      </tr>
    </ng-template>

    <!-- Table Body - Desktop View -->
    <ng-template pTemplate="body" let-item let-expanded="expanded">
      <!-- Desktop Table Row -->
      <tr class="desktop-row workflow-row" (click)="toggleRowExpansion(item)">
        <!-- Row Expansion Toggle (Frozen Left) -->
        <td
          class="text-center expand-column"
          pFrozenColumn
          [frozen]="true"
          alignFrozen="left"
          (click)="$event.stopPropagation()"
        >
          <span class="p-column-title">Expand</span>
          <p-button
            [pRowToggler]="item"
            type="button"
            pRipple
            [text]="true"
            [rounded]="true"
            [plain]="true"
            size="small"
            styleClass="text-gray-400 hover:text-gray-600"
            [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"
            [disabled]="loading"
            pTooltip="Click to expand/collapse details"
            tooltipPosition="top"
          />
        </td>

        <!-- ID Column (Frozen Left) - Clickable -->
        <td class="id-column" pFrozenColumn [frozen]="true" alignFrozen="left">
          <span class="p-column-title">ID</span>
          <a
            href="javascript:;"
            class="id-link"
            (click)="onRowEdit(item); $event.stopPropagation()"
          >
            {{ item.survey.id }}
          </a>
        </td>

        <!-- Name Column -->
        <td class="name-column">
          <span class="p-column-title">Name</span>
          <span
            class="survey-name"
            [pTooltip]="item.survey.name"
            tooltipPosition="top"
          >
            {{ item.survey.name }}
          </span>
        </td>

        <!-- Trigger Column -->
        <td class="trigger-column">
          <span class="p-column-title">Trigger</span>
          <p-tag
            [value]="getActionTriggerLabel(item.survey.actionTrigger)"
            [severity]="getActionTriggerSeverity(item.survey.actionTrigger)"
          />
        </td>

        <!-- Enabled Column -->
        <td
          class="enabled-column text-center"
          (click)="$event.stopPropagation()"
        >
          <span class="p-column-title">Enabled</span>
          <p-toggleSwitch
            [(ngModel)]="item.survey.isEnabled"
            (onChange)="onEnabledToggle(item)"
            [disabled]="loading"
          />
        </td>

        <!-- Created Column -->
        <td class="created-column">
          <span class="p-column-title">Created</span>
          <span class="date-value">{{ formatDate(item.createdDate) }}</span>
        </td>

        <!-- First Response Column (hidden on mobile) -->
        <td class="first-response-column desktop-only-cell">
          <span class="p-column-title">First Response</span>
          <span class="date-value">{{
            formatDate(item.firstResponseDate)
          }}</span>
        </td>

        <!-- Last Response Column (hidden on mobile) -->
        <td class="last-response-column desktop-only-cell">
          <span class="p-column-title">Last Response</span>
          <span class="date-value">{{
            formatDate(item.lastResponseDate)
          }}</span>
        </td>

        <!-- Actions Column (Frozen Right) -->
        <td
          class="actions-column text-center"
          pFrozenColumn
          [frozen]="true"
          alignFrozen="right"
          (click)="$event.stopPropagation()"
        >
          <span class="p-column-title">Actions</span>
          <p-button
            icon="pi pi-ellipsis-v"
            [text]="true"
            size="small"
            [disabled]="loading"
            (click)="toggleRowMenu($event, item)"
            pTooltip="Actions"
            tooltipPosition="left"
          />
        </td>
      </tr>

      <!-- Mobile Card Row -->
      <tr class="mobile-card-row">
        <td colspan="9">
          <!-- Mobile Card -->
          <div
            class="mobile-card"
            [class.expanded]="expanded"
            [class.status-enabled]="item.survey.isEnabled"
            [class.status-disabled]="!item.survey.isEnabled"
          >
            <!-- Card Header: ID, Status Badge, Actions -->
            <div class="mobile-card-header">
              <div class="mobile-card-header-left">
                <!-- Expand Toggle -->
                <p-button
                  [pRowToggler]="item"
                  type="button"
                  [text]="true"
                  [rounded]="true"
                  [plain]="true"
                  size="small"
                  styleClass="expand-toggle-btn"
                  [icon]="
                    expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'
                  "
                />
              </div>

              <div class="mobile-card-header-center">
                <!-- ID Link -->
                <a
                  href="javascript:;"
                  class="mobile-card-id"
                  (click)="onRowEdit(item); $event.stopPropagation()"
                >
                  #{{ item.survey.id }}
                </a>
                <!-- Enabled Badge -->
                <p-tag
                  [value]="item.survey.isEnabled ? 'Enabled' : 'Disabled'"
                  [severity]="item.survey.isEnabled ? 'success' : 'secondary'"
                />
              </div>

              <div class="mobile-card-header-right">
                <!-- Actions Menu -->
                <p-button
                  icon="pi pi-ellipsis-v"
                  [text]="true"
                  size="small"
                  (click)="
                    toggleRowMenu($event, item); $event.stopPropagation()
                  "
                />
              </div>
            </div>

            <!-- Card Body: Name - Clickable to expand -->
            <div class="mobile-card-body" [pRowToggler]="item">
              <div class="mobile-card-name">{{ item.survey.name }}</div>
              <div class="mobile-card-trigger">
                <span class="mobile-card-trigger-label">Trigger:</span>
                <p-tag
                  [value]="getActionTriggerLabel(item.survey.actionTrigger)"
                  [severity]="
                    getActionTriggerSeverity(item.survey.actionTrigger)
                  "
                />
              </div>
            </div>

            <!-- Card Footer: Compact Info Display with Vertical Separators -->
            <div class="mobile-card-footer" [pRowToggler]="item">
              <div class="mobile-card-info-inline">
                <!-- Created -->
                <div class="mobile-card-info-item">
                  <span class="mobile-card-info-label">CREATED</span>
                  <span class="mobile-card-info-value">{{
                    formatDate(item.createdDate)
                  }}</span>
                </div>
                <!-- Separator -->
                <span class="mobile-card-separator"></span>
                <!-- First Response -->
                <div class="mobile-card-info-item">
                  <span class="mobile-card-info-label">FIRST RESP</span>
                  <span class="mobile-card-info-value">{{
                    formatDate(item.firstResponseDate)
                  }}</span>
                </div>
                <!-- Separator -->
                <span class="mobile-card-separator"></span>
                <!-- Last Response -->
                <div class="mobile-card-info-item">
                  <span class="mobile-card-info-label">LAST RESP</span>
                  <span class="mobile-card-info-value">{{
                    formatDate(item.lastResponseDate)
                  }}</span>
                </div>
              </div>
            </div>
          </div>
        </td>
      </tr>
    </ng-template>

    <!-- Row Expansion Template -->
    <ng-template pTemplate="expandedrow" let-item>
      <tr class="expanded-row">
        <td colspan="9" class="expanded-row-cell">
          <div class="expanded-row-content">
            <!-- Quick Actions -->
            <div class="quick-actions-section">
              <p-button
                [label]="item.hasCustomerAnswer ? 'View' : 'Edit'"
                [icon]="item.hasCustomerAnswer ? 'pi pi-eye' : 'pi pi-pencil'"
                size="small"
                severity="secondary"
                [outlined]="true"
                (click)="onRowEdit(item)"
              />
              <p-button
                label="Duplicate"
                icon="pi pi-copy"
                size="small"
                severity="secondary"
                [outlined]="true"
                (click)="onRowDuplicate(item)"
              />
              <p-button
                label="Delete"
                icon="pi pi-trash"
                size="small"
                severity="danger"
                [outlined]="true"
                (click)="onRowDelete(item)"
              />
            </div>

            <!-- Workflow Details -->
            <div class="detail-section">
              <div class="section-header">Workflow Details</div>
              <dl class="detail-list">
                <div class="detail-item">
                  <dt>Survey ID</dt>
                  <dd>{{ item.survey.id }}</dd>
                </div>
                <div class="detail-item">
                  <dt>Trigger Type</dt>
                  <dd>
                    {{ getActionTriggerLabel(item.survey.actionTrigger) }}
                  </dd>
                </div>
                <div class="detail-item">
                  <dt>Status</dt>
                  <dd>{{ item.survey.isEnabled ? "Enabled" : "Disabled" }}</dd>
                </div>
              </dl>
            </div>

            <!-- Response Statistics -->
            <div class="detail-section">
              <div class="section-header">Response Info</div>
              <dl class="detail-list">
                <div class="detail-item">
                  <dt>Has Responses</dt>
                  <dd>{{ item.hasCustomerAnswer ? "Yes" : "No" }}</dd>
                </div>
                <div class="detail-item">
                  <dt>Created</dt>
                  <dd>{{ formatDate(item.createdDate) }}</dd>
                </div>
                <div class="detail-item">
                  <dt>First Response</dt>
                  <dd>{{ formatDate(item.firstResponseDate) }}</dd>
                </div>
                <div class="detail-item">
                  <dt>Last Response</dt>
                  <dd>{{ formatDate(item.lastResponseDate) }}</dd>
                </div>
              </dl>
            </div>
          </div>
        </td>
      </tr>
    </ng-template>

    <!-- Empty State -->
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="9" class="text-center py-8">
          <div class="empty-state">
            <i class="pi pi-inbox text-4xl text-gray-300 mb-3"></i>
            <p class="text-gray-500 mb-0">No retention workflows found</p>
            <p class="text-gray-400 text-sm">
              Create a workflow to start capturing customer feedback
            </p>
          </div>
        </td>
      </tr>
    </ng-template>

    <!-- Loading State -->
    <ng-template pTemplate="loadingbody">
      <app-table-skeleton-rows [rows]="5" [columns]="skeletonColumns" />
    </ng-template>
  </p-table>

  <!-- Context Menu -->
  <p-menu
    #contextMenu
    [popup]="true"
    [model]="contextMenuItems"
    appendTo="body"
  />
</div>
